export const AUTHENTICATION_STORAGE_NAME = 'authentication';
export const SESSION_ID_NAME = 'session_id';
